<template>
  <flipbook class="flipbook" :pages="pages"></flipbook>
</template>

<style>
html {
  display: flex;
  height: -webkit-fill-available;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
  background-image: url("https://images.unsplash.com/photo-1555505019-8c3f1c4aba5f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8d29vZGVuJTIwYmFja2dyb3VuZHxlbnwwfHwwfHw%3D&w=1000&q=80");
}

body {
  /* Max size */
  width: 95vw;
  height: 90vh;
  overflow: hidden;
}

.flipbook {
  width: 100%;
  height: 100%;
}
</style>
<script>
import Flipbook from 'flipbook-vue'
export default {
  components: { Flipbook },
  data() {
    return {
      pages : [
        'https://raw.githubusercontent.com/Jhongt796/imghosts/main/1.png',
        'https://raw.githubusercontent.com/Jhongt796/imghosts/main/2.png',
        'https://raw.githubusercontent.com/Jhongt796/imghosts/main/3.png',
        'https://raw.githubusercontent.com/Jhongt796/imghosts/main/4.png',
        'https://raw.githubusercontent.com/Jhongt796/imghosts/main/5.png',
        'https://raw.githubusercontent.com/Jhongt796/imghosts/main/6.png',
        'https://raw.githubusercontent.com/Jhongt796/imghosts/main/7.png',
        'https://raw.githubusercontent.com/Jhongt796/imghosts/main/8.png',
        'https://raw.githubusercontent.com/Jhongt796/imghosts/main/9.png',
        'https://raw.githubusercontent.com/Jhongt796/imghosts/main/10.png',
        'https://raw.githubusercontent.com/Jhongt796/imghosts/main/11.png',
        'https://raw.githubusercontent.com/Jhongt796/imghosts/main/12.png',
        'https://raw.githubusercontent.com/Jhongt796/imghosts/main/13.png',
        'https://raw.githubusercontent.com/Jhongt796/imghosts/main/14.png',
        'https://raw.githubusercontent.com/Jhongt796/imghosts/main/15.png',
        'https://raw.githubusercontent.com/Jhongt796/imghosts/main/16.png',
      ]
    }
  }
}
</script>